import { AppDispatch, AppState } from "src/features";
import { activateLocationMarkerDeepLink } from "../../deeplink/actions/activateLocationMarkerDeepLink";
import { deleteTableToken, getTableToken } from "../persistence/tableToken";
import { MEANDU_REGION_KEY } from "../../region/middleware/regionMiddleware";

export function retryJoinTable() {
    return (dispatch: AppDispatch, getState: () => AppState) => {
        const data = getState().deepLink.data;
        if (!data) return;

        // retryJoinTable calls activateLocationMarkerDeepLink directly, bypassing
        // the normal LOADING → GET /region → CHANGED chain that writes MEANDU_REGION.
        // Replace the stored region from the URL's r parameter so the retry uses
        // the correct regional database.
        try {
            const region = new URL(data.claimUrl).searchParams.get("r");
            if (region) {
                localStorage.setItem(MEANDU_REGION_KEY, region);
            }
        } catch {}

        // A stale token from another environment can cause transient failures.
        // Clear it so the retry authenticates fresh, matching what a hard reload would do.
        const existingToken = getTableToken();
        if (existingToken) {
            deleteTableToken("failed_rejoin");
        }

        dispatch(activateLocationMarkerDeepLink(data.claimUrl, data.type, null));
    };
}
